import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";

// components
import Breadcrumb from "./breadcrumb";
import Price from "./price";
import Colors from "./colors";
import AdditionalInfo from "./additionalInfo";
import ConfirmPopup from "../common/confirmPopup";
import { FaHeadphonesAlt } from "react-icons/fa";
import { BsWhatsapp } from "react-icons/bs";
import { FaRegShareFromSquare } from "react-icons/fa6";

// functions
import {
  deleteItemFromCart,
} from "../../functions/cart.js";

// style
import style from "../../pages/productDetails/productDetails.module.css";
import axiosInstance from "../../apis/config.js";
import { showToast } from "../../store/slices/toastSlice.js";
import companyData from "../../companyData.js";

const Details = ({ product }) => {
  const [activeColor, setActiveColor] = useState("");
  const [activeQuantity, setActiveQuantity] = useState(1);
  const [inCart, setInCart] = useState(false);
  // const [terms, setTerms] = useState(false);
  const [showWarning, setShowWarning] = useState(false);
  const [showBuyBtnSpinner, setShowBuyBtnSpinner] = useState(false);
  const cart = useSelector((state) => state.cart.cart);
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const handleColorChange = (color) => {
    setActiveColor(color);
    if (!cart.items) return;
    // find if user added this color to cart
    const item = cart.items.find(
      (ele) => ele.product_id._id === product._id && color.color === ele.color
    );
    if (item) {
      setActiveQuantity(item.quantity);
      setInCart(true);
    } else {
      setInCart(false);
    }
  };


  const handleDeleteFromCart = () => {
    deleteItemFromCart(cart._id, product._id, activeColor.color);
    setShowWarning(false);
  };

  useEffect(() => {
    // wait untill product added to cart then navigate to checkout
    if (showBuyBtnSpinner) {
      navigate("/checkout");
      setShowBuyBtnSpinner(false);
    }
    // eslint-disable-next-line
  }, [inCart]);

  useEffect(() => {
    if (product) {
      // check if user is logged in and not admin
      if (cart.items?.length > 0) {
        let item;
        // check if there's change in cart and affected current chosen color while user is on this page
        if (activeColor) {
          item = cart.items.find(
            (ele) =>
              ele.product_id._id === product._id &&
              ele.color === activeColor.color
          );
          if (item) {
            const newActiveColor = product.colors.find(
              (color) => color.color === item.color
            );
            setActiveQuantity(item.quantity);
            setActiveColor(newActiveColor);
            setInCart(true);
          } else {
            setInCart(false);
          }
          return;
        } else {
          // check if user just navigated to page
          item = cart.items.find((ele) => ele.product_id._id === product._id);
          if (item) {
            const newActiveColor = product.colors.find(
              (color) => color.color === item.color
            );
            setActiveQuantity(item.quantity);
            setActiveColor(newActiveColor);
            setInCart(true);
            return;
          }
        }
      }
      // user not logged in
      const firstInStockColor =
        product.colors.find((ele) => ele.stock > 0) || product.colors[0];
      setActiveColor(firstInStockColor);
      setInCart(false);
    }
    // eslint-disable-next-line
  }, [product, cart]);

  const [accessories, setAccessories] = useState(null);

  const brandId = "669a1aa06c53522ac71800b8"; //THIS IS A ACCESSORIES ID, SHOULD BE CHANGED IN CASE IF ACESSORIES in BRAND

  useEffect(() => {
    const getData = (
      page = 1,
      brand = brandId,
      category = product.category._id,
      sort = 0,
      price = 0
    ) => {
      setAccessories(null);
      axiosInstance
        .get("/products", {
          params: {
            page,
            brand,
            category,
            sort,
            price,
          },
        })
        .then((res) => {
          const shuffledProducts = res.data.data.sort(
            () => Math.random() - 0.5
          );
          setAccessories(shuffledProducts);
        })
        .catch((error) => console.log(error));
    };
    getData();
    // eslint-disable-next-line
  }, []);

  const shareToSocialMedia = (value, imageUrl) => {
    if (navigator.share) {
      const shareData = {
        title: "Check out this product!",
        text: "Product Link: " + value,
        url: value,
      };

      const files = [];
      if (imageUrl) {
        fetch(imageUrl)
          .then((response) => response.arrayBuffer())
          .then((imageBuffer) => {
            const imageFile = new File([imageBuffer], "product_image.jpg", {
              type: "image/jpeg",
            });

            files.push(imageFile);
            shareData.files = files;

            navigator
              .share(shareData)
              .then(() => {
                console.log("Product link and image shared successfully!");
              })
              .catch((error) => {
                console.error("Error sharing:", error);
              });
          })
          .catch((error) => {
            console.error("Error fetching image:", error);
            navigator.share(shareData);
          });
      } else {
        navigator.share(shareData);
      }
    } else {
      copyToClipboard(value);
    }
  };
  const copyToClipboard = (value) => {
    navigator.clipboard.writeText(value);
    dispatch(showToast("Link Copied!"));
  };

  console.log("product", product);
  console.log("product accesoories", accessories);

  const searchAccesories = (categoryId) => {
    navigate(
      `/shop?page=1&brand=${brandId}&category=${categoryId}&sort=0&price=0` //THIS IS A ACCESSORIES ID, SHOULD BE CHANGED IN CASE IF ACESSORIES in BRAND
    );
  };

  return product ? (
    <>
      <Breadcrumb name={product.name} />
      <h5 className="mb-3 mt-4">{product.name}</h5>
      <Price
        price={product.price}
        discount={product.discount}
        rating={product.ratings}
        reviews={product.reviews?.length}
      />
      <p
        className={`${style.description} overflow-hidden mt-3 mb-4 color-secondary-gray`}
        dangerouslySetInnerHTML={{ __html: product.description }}
      ></p>
      <div className="border-top border-bottom py-4">
        <div className="d-flex align-items-center gap-2 mb-4">
          <span className="fw-semibold">Stock:</span>
          <span
            className={
              activeColor.stock === 0 || activeQuantity > activeColor.stock
                ? "text-danger"
                : ""
            }
          >
            {activeColor.stock > 0 ? activeColor.stock : "Out Of Stock"}
          </span>
        </div>
        <div className="d-block align-items-center gap-3 mb-4">
          {/* <h3 className="h6 mb-0 fw-semibold">colors & size:</h3> */}
          <h3 className="h6 mb-0 fw-semibold">colors:</h3>
          <Colors
            colors={product.colors}
            active={activeColor}
            onColorChange={handleColorChange}
          />
        </div>
     

        <div className="d-block d-sm-flex gap-1 flex-wrap">
          {/* WhatsApp Button */}
          <a
            href={`https://wa.me/254${companyData.whatsapp}?text=I am interested in: ${product.name}`}
            target="_blank"
            rel="noopener noreferrer"
            className="btn text-white text-capitalize px-5 rounded-2 d-block mx-auto"
            style={{ backgroundColor: "#25d366", marginBottom: "2px" }}
          >
            <BsWhatsapp style={{ marginRight: "5px" }} /> WhatsApp Us
          </a>

          {/* Call Us Button */}
          <a
            href={`tel:${companyData.phone}`}
            className="btn btn-bg-dark text-white text-capitalize px-5 rounded-2 d-block mx-auto"
          >
            <FaHeadphonesAlt
              style={{ marginRight: "5px", marginBottom: "2px" }}
            />
            Call Us
          </a>
          {/* share button */}
          <button
            onClick={() =>
              shareToSocialMedia(
                `${`/product-details/${product._id}`}`,
                product.documents && product.documents[0]?.url
              )
            }
            className="btn text-white text-capitalize px-5 rounded-2 d-block mx-auto max-w-full lg:max-w-[50px] "
            style={{
              marginBottom: "2px",
              marginTop: "2px",
              // maxWidth: "50px",
              backgroundColor: "#c7ab62",
            }}
          >
            <FaRegShareFromSquare style={{ marginRight: "5px" }} />
          </button>
        </div>
      </div>
      <div className="py-4">
        {accessories?.length !== 0 && product.brand._id !== brandId && (
          <button
            type="button"
            className="btn my-3 py-2 d-block w-100 btn-bg-dark text-white text-capitalize"
            onClick={() => searchAccesories(product.category._id)}
          >
            Include {product.category.name} accessories
          </button>
        )}

        
        
        <AdditionalInfo product={product} />
      </div>
      {showWarning && (
        <ConfirmPopup
          msg={"Are you sure you want to delete from cart?"}
          onConfirm={handleDeleteFromCart}
          onCancel={() => setShowWarning(false)}
        />
      )}
    </>
  ) : (
    ""
  );
};

export default Details;
